<div class="info">
  <Panel bind:expanded={show}>
    <div slot="title" class="title-wrap">
      <span class="title">{title}</span>
      <button type="button" on:click={() => (show = !show)}>
        <span>{show ? 'Lees minder' : 'Lees meer'}</span>
        <Chevron up={show} />
      </button>
    </div>
    <div class="details">
      <p>{@html details}</p>
      <hr />
      {#if imgSrc}
        <div>
          <img src={imgSrc} alt="info" />
        </div>
      {/if}
    </div>
  </Panel>
</div>

<script>
  import Panel from './ExpansionPanel.svelte';
  import Chevron from './Chevron.svelte';
  let show = false;

  export let title;
  export let details;
  export let imgSrc = undefined;
</script>

<style lang="postcss">
  .info {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    @apply px-12 pt-10 pb-12 z-10;
  }

  .title-wrap {
    @apply flex flex-col;
  }

  .title {
    font-weight: 500;
    @apply text-xl;
  }

  .details {
    @apply pt-3;
  }

  hr {
    @apply mt-5 mb-10 border-dashed;
  }

  img {
    @apply w-full object-cover object-center;
  }

  button {
    @apply mt-5 flex items-center;
  }

  button span {
    @apply text-primary;
  }

  span {
    @apply mr-3;
  }

  .info :global(svg) {
    @apply -mb-1;
  }

  @screen sm {
    .info {
      @apply px-0 py-16;
    }
    .title-wrap {
      @apply flex-row;
    }
    .title {
      @apply px-16 mr-0 text-2xl w-3/5;
    }
    button {
      @apply mt-0;
    }
    .details {
      @apply pt-5 flex;
    }
    p {
      @apply pl-16 pr-12 w-3/5 flex-shrink-0;
    }
    .details div, button {
      @apply mr-16;
    }
    hr {
      @apply hidden;
    }
  }

  @screen md {
    .info {
      @apply max-w-xl pb-5 mb-12;
    }

    button {
      @apply hidden;
    }

    .info :global(.title-wrap + div) {
      height: 100% !important;
    }

    .info :global(.content) {
      @apply block;
    }

    .title {
      @apply w-auto px-16;
    }

    .details {
      @apply block;
    }

    p {
      @apply w-auto mx-16 p-0;
    }

    hr {
      @apply block mt-10 mb-16 mx-16;
    }

    .details > div {
      @apply mx-5 relative;
    }

    img {
      @apply w-full m-0 object-bottom;
    }
  }
</style>